import { Typography } from '@mui/material';
import type { FC } from 'react';
import React, { useState } from 'react';
import { mutate } from 'swr';

import ConfirmModal from '@/components/UI/mobile/V2/ConfirmModal';
import axiosWithAuth from '@/lib/axios';

import { getPostalItemsUrl } from '../../constant';
import type { Postal } from '../../types';
import Info from './Info';
import {
  ActionBox,
  CheckButton,
  DetailBox,
  Divider,
  HeaderBox,
  MainBox,
  OpenButton,
  Status,
} from './styles';

const PostalItem: FC<{ postal: Postal; showDetail: () => void }> = ({
  postal,
  showDetail,
}) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleOpenDoor = async () => {
    try {
      await axiosWithAuth.post('/ezcon/api/ultraLocker/resident/openLocker', {
        postalId: postal.id,
      });
      mutate((key) => {
        if (typeof key === 'string') {
          return key.startsWith(getPostalItemsUrl);
        }
        return false;
      });
      setShowConfirmModal(false);
    } catch (error) {
      console.error(error);
      setErrorMessage(error.displayMessage ?? '請稍候再試');
    }
  };

  return (
    <MainBox>
      <HeaderBox>
        <Status $status={postal.status}>{postal.status}</Status>
        <Typography
          sx={{
            fontWeight: '500',
            fontSize: '0.9rem',
          }}
        >
          {postal.createdTime}
        </Typography>
      </HeaderBox>
      <DetailBox>
        <Info label="編號" value={postal.plateNumber} />
        <Info label="收件人" value={postal.receiver} />
        <Info label="類型" value={postal.type} />
        <Info label="擺放位置" value={postal.position} />
      </DetailBox>
      <ActionBox>
        <CheckButton onClick={showDetail}>查看更多</CheckButton>
        {postal.status === '未領取' && (
          <>
            <Divider />
            <OpenButton
              disabled={!postal.isOpenable}
              onClick={() => setShowConfirmModal(true)}
            >
              打開櫃門
            </OpenButton>
          </>
        )}
      </ActionBox>
      {showConfirmModal && (
        <ConfirmModal
          title="開啟無人置物櫃"
          content="置物櫃開啟後需手動關閉"
          onConfirm={handleOpenDoor}
          confirmText="確認"
          onCancel={() => setShowConfirmModal(false)}
          cancelText="取消"
        />
      )}
      {errorMessage && (
        <ConfirmModal
          title="發生異常"
          content={errorMessage}
          onConfirm={() => setErrorMessage(null)}
          confirmText="確認"
        />
      )}
    </MainBox>
  );
};

export default PostalItem;
